














import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import Postmate from 'postmate';
import $ from 'jquery';
import { Mutation, Action, Getter } from 'vuex-class';
import BaseView from '../BaseView';
import Common from '../helper/Common';

import { AudienceDetails } from '../models/AudienceDetails';

import StatisticsPanel from '@/components/StatisticsPanel.vue';
import { StatisticsPanelModel } from '../models/StatisticsPanelModel';

const namespace: string = 'counter';

@Component({
    components: {
        StatisticsPanel
    },
})
export default class CriteriaPreview extends BaseView {

    @Prop({ default: true })
    public showCounts!: boolean;

    @Prop({ default: null })
    public AudienceDetail!: AudienceDetails;

    @Prop({ default: 0 })
    public DetailID!: number;
    @Prop({ default: 0 })
    public ClientID!: number;

    @Prop({ default: '' })
    public CurrentDetailType!: string;
    @Prop({ default: false })
    public IsActive!: boolean;

    @Prop({ default: true })
    public LoadDataOnMounted!: boolean;
    // @Prop({ default: 'criteriaPreviewContainer' })
    // public containerClass!: string;

    @Prop({ default: 'criteriaPreviewContainer' })
    public containerID!: string;

    private $v: any;
    private editingName: boolean = false;
    private criteriaJson: string = '';
    private isLoaded: boolean = false;
    private leftCriteriaMessage: string = 'If you close your Audience now, your changes will be lost.';
    private toggleSelectionToolTip: string = '';
    private canGenerateCounts: boolean = false;
    private statisticsRequestId: number = 0;
    private statisticsKey: number = 0;
    private totalRecords: number | null = null;
    private canViewCounts: boolean = true;
    private isGeneratingCounts: boolean = false;
    private criteriaEditorIsModified: boolean = false;
    private showEmDashAsCounts: boolean = false;
    private nameFieldSelectedBeforeCriteriaLoaded: boolean = false;
    private nameContainerWidth: number = 0;
    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private statisticsPanelPlaceholderID: string = 'statisticsPanelPlaceholder_' + this.containerID;

    private postmate!: any;

    @Getter('currentClientId', { namespace })
    private currentClient!: number;

    public updateSize() {
        console.log('CriteriaPreview updateSize Called');
        this.postmate.then((child) => {
            child.get('width')
                .then((width) => {
                    child.frame.style.width = `${width}`;
                    child.frame.style.border = '0px';
                });
            child.get('height')
                .then((height) => {
                    if (height < 1) { return; }
                    // height += 50; // to match on height change logic
                    child.frame.style.height = `${height}px`;
                });
            });
    }

    private loadData() {

        // Create the Postmate iframe
        this.postmate = new Postmate({
            // container: $(`div.${this.containerClass}`)[0],
            container: $(`div#${this.containerID}`)[0],
            url: '/legacy/criteria/preview.html'
        });

        this.postmate.then((child) => {
            child.on('criteria_preview_change_height', (height) => {
                console.log('CriteriaPreview Child::on::heightchange', height);
                if (height > 1) {
                    // height = height + 50;
                    child.frame.style.height = `${height}px`;
                }
            });

            child.on('criteria_preview_get_statistics', (data) => {
                this.openStatisticsPopOver(data.width);
            });
        });

        this.postmate.then((child) => {
            Common.blockElement(this.containerID);
            window.App.$axios.get(`/api/einsightLegacy/api.mvc/audience/DynamicCriteriaData?eInsightDomain=${encodeURIComponent(window.App.$appSettings.eInsightUri)}&Audience_Details_Id=${this.DetailID}&client_id=${this.ClientID}&preview=true&api_user=${window.eInsightUserEmail}`)
                .then((response) => {
                    console.log('response.data: ', response.data);
                    response.data.TAGS = this.AudienceDetail.Tags;
                    response.data.DESCRIPTION = this.AudienceDetail.Description;

                    console.log('before criteria_preview_load', response.data);

                    child.call('criteria_preview_load', response.data);
                    Common.unblockElement(this.containerID);
                    // $('div.loading-summary-tab').hide();
                });
            // TODO: add a catch to the Promise to remove the modal
            // and alert the user that the summary data failed to load properly
         });

    }

    private mounted() {
        if (this.LoadDataOnMounted) {
            // Wire up child frame emit events
            this.loadData();
        }
    }





    private countsState(): string {
        if (!this.showCounts) {
            return '';
        }
        // if (this.criteriaEditorIsModified || this.$v.audienceDetails.Properties.$dirty) {
        if (this.criteriaEditorIsModified) {
            return '';
        }

        if (this.isGeneratingCounts) {
            return 'generating';
        }

        if (this.isLoaded && this.canViewCounts) {
            return 'counts';
        }
        return '';
    }

    private openStatisticsPopOver(parentButtonWidth) {
        console.log('isActive: ', this.IsActive);
        console.log('CurrentDetailType: ', this.CurrentDetailType);
        console.log('statisticsPanelPlaceholderID: ', this.statisticsPanelPlaceholderID);

        if (this.IsActive) {

            $('#' + this.statisticsPanelPlaceholderID).width(parentButtonWidth + 20 + 'px');
            // if (this.statisticsPanelPlaceholderID.endsWith('1')) {
            //    $('#' + this.statisticsPanelPlaceholderID).css({ 'border': 'solid 2px blue' });
            // }
            // else {
            //    $('#' + this.statisticsPanelPlaceholderID).css({ 'border': 'solid 2px red' });
            // }
            const target: HTMLElement | null = document.getElementById(this.statisticsPanelPlaceholderID);
            console.log('this.containerID: ', this.containerID);
            console.log('target: ', target);

            const statisticsPanel: any = this.$refs.statisticsPanelRef;

            console.log('statisticsPanel: ', statisticsPanel);

            let requestId: number | null = this.statisticsRequestId;
            if (requestId < 0) {
                requestId = null;
            }

            if (statisticsPanel) {
                statisticsPanel.fetchStatistics(new StatisticsPanelModel(
                    this.ClientID,
                    this.AudienceDetail.AudienceDetailsID,
                    target as HTMLElement,
                    requestId,
                    true,
                    true,
                    true));
            }

            // $('#panel').css({'transform':'none'});
        }
    }

    private onStatisticsCompleted(data: any): void {

        console.log('completed: ', data);

        // if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
        //    return;
        // }
        this.totalRecords = data.totalCount;
        this.statisticsRequestId = -1;
        this.isGeneratingCounts = false;
        this.showEmDashAsCounts = false;

        const statisticsPanel: any = this.$refs.statisticsPanelRef;

        console.log('statisticsPanel: ', statisticsPanel);

        const statistics = statisticsPanel.getCurrentStatistics();
        this.postmate.then((child) => {
            child.call('criteria_preview_update_statistics', statistics.data);
        });
    }

    private onStatisticsGenerating(data: any): void {

        console.log('generating: ', data);

        if (this.countsState() === '') {
            return;
        }
        this.statisticsRequestId = data.reqiestId;
        this.isGeneratingCounts = true;
    }

    private onStatisticsError(data: any): void {

        console.log('stats error: ', data);

        // if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
        //    return;
        // }
        this.isGeneratingCounts = false;
        this.statisticsRequestId = -1;
    }

    private onStatisticsCancel(data: any): void {

        console.log('stats cancel: ', data);

        // if (this.statisticsRequestId !== 0 && this.statisticsRequestId !== data.reqiestId) {
        //    return;
        // }
        this.isGeneratingCounts = false;
        this.statisticsRequestId = -1;
    }
}
